// Studio Creator Tools — Custom Stickers
import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import LiveKitSetupCard from "../components/LiveKitSetupCard";
import { Sparkles, Plus, Trash2 } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function StudioTools() {
  const { user } = useAuth();
  if (!user) return <div className="p-20 text-center text-white/40">Sign in as creator.</div>;
  return (
    <div className="max-w-[1500px] mx-auto space-y-8" data-testid="studio-tools">
      <Toaster theme="dark" position="top-center" />
      <div>
        <div className="label-eyebrow mb-2">// creator tools</div>
        <h1 className="font-display font-black text-4xl lg:text-5xl tracking-tighter">Custom Stickers.</h1>
      </div>
      <LiveKitSetupCard compact subtitle="Connect a LiveKit Cloud project so your stickers show up when you go live." />
      <MyStickers user={user} />
    </div>
  );
}

function MyStickers({ user }) {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ name: "", emoji: "✨", price: 5, tier: "paid", animation: "float", color: "#00F0FF" });
  const studio = user.membership_tier === "studio" || user.role === "owner";
  const load = () => api.get(`/creator/${user.id}/stickers`).then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.name) { toast.error("Name required"); return; }
    try { await api.post("/creator/stickers", { ...form, price: parseFloat(form.price) }); toast.success("Sticker saved"); setForm({ name: "", emoji: "✨", price: 5, tier: "paid", animation: "float", color: "#00F0FF" }); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { await api.delete(`/creator/stickers/${id}`); load(); };
  if (!studio) return <div className="glass p-6 text-center"><Sparkles className="w-8 h-8 mx-auto text-nexus-cyan mb-3" /><div className="font-display">Custom stickers are a Studio-tier feature.</div><a href="/pricing" className="btn-nexus inline-flex mt-4">See tiers</a></div>;
  return (
    <div className="space-y-4">
      <p className="text-xs text-white/60">Design stickers exclusive to your channel. Pick emoji, color, animation, and the price viewers pay in NX.</p>
      <div className="glass p-5 grid sm:grid-cols-6 gap-3 items-end">
        <div><div className="label-eyebrow mb-2">name</div><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-transparent border border-white/10 px-3 py-2 text-sm" /></div>
        <div><div className="label-eyebrow mb-2">emoji</div><input value={form.emoji} onChange={(e) => setForm({ ...form, emoji: e.target.value })} className="w-full bg-transparent border border-white/10 px-3 py-2 text-sm text-center" /></div>
        <div><div className="label-eyebrow mb-2">price NX</div><input type="number" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} className="w-full bg-transparent border border-white/10 px-3 py-2 text-sm" /></div>
        <div><div className="label-eyebrow mb-2">color</div><input value={form.color} onChange={(e) => setForm({ ...form, color: e.target.value })} className="w-full bg-transparent border border-white/10 px-3 py-2 text-sm font-mono" /></div>
        <div><div className="label-eyebrow mb-2">tier</div><select value={form.tier} onChange={(e) => setForm({ ...form, tier: e.target.value })} className="w-full bg-nexus-surface border border-white/10 px-3 py-2 text-sm"><option value="paid">paid</option><option value="premium">premium</option><option value="elite">elite</option></select></div>
        <button onClick={save} className="btn-nexus" data-testid="save-custom-sticker"><Plus className="w-3.5 h-3.5" /> Add</button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-px bg-white/5">
        {list.length === 0 && <div className="col-span-full bg-nexus-surface p-6 text-white/40 text-sm text-center">No custom stickers yet.</div>}
        {list.map((s) => (
          <div key={s.id} className="bg-nexus-surface p-5 text-center">
            <div className="text-5xl" style={{ filter: `drop-shadow(0 0 12px ${s.color})` }}>{s.emoji}</div>
            <div className="text-sm font-medium mt-3">{s.name}</div>
            <div className="text-[10px] tracking-[0.3em] uppercase mt-1" style={{ color: s.color }}>{s.tier} · {s.price} NX</div>
            <button onClick={() => del(s.id)} className="text-white/40 hover:text-nexus-crimson mt-3"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}

